<template>
  <div id="insider-backtester-insider-restrictions-tab">
    <v-container fluid pa-0>
      <v-row>
        <!-- Optionally Restrict to Specific Insiders -->
        <v-col cols="12" mb-6>
          <helpers-section-sub-header class="mb-6">
            Optionally restrict to specific insiders:
          </helpers-section-sub-header>

          <core-fund-group-manager
            v-model:filer-group="restrictTo"
            insiders
            optional
            text
            no-padding
          />
        </v-col>

        <!-- Optionally Exclude Specific Insiders -->
        <v-col cols="12" mb-6>
          <helpers-section-sub-header class="mb-6">
            Optionally exclude specific insiders:
          </helpers-section-sub-header>

          <core-fund-group-manager
            v-model:filer-group="excluded"
            insiders
            optional
            text
            no-padding
          />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
// Modules
import { mapFields } from '@/store/helpers'

export default {
  data() {
    return {
      restrictTo: {
        id: null,
        description: 'New Group',
        visibility_type_id: 0,
        filers: []
      },
      excluded: {
        id: null,
        description: 'New Group',
        visibility_type_id: 0,
        filers: []
      }
    }
  },

  computed: {
    ...mapFields({
      criteria: 'app.insiderBacktesterCriteria'
    })
  },

  watch: {
    'restrictTo.filers'(array) {
      this.criteria.entry_owners = array
    },

    'excluded.filers'(array) {
      this.criteria.excluded_owners = array
    }
  }
}
</script>
